/**
 * @Descripttion: 图片发送服务 - 复用话术图片发送到吸附窗口的链路
 * 图片URL -> fetch -> Image -> canvas -> PNG blob -> 剪贴板 -> (Electron) ipc 'type-img'
 * 提取自 Home.vue 的 copyImage(imageUrl) 与 ImageList.vue 的发送逻辑
 * @version:
 * @Author: geory
 * @Date: 2026-08-14
 */

//是否运行在Electron环境中（与 src/common/js/common.js 的 isElectron 一致）
function isElectron() {
  return (
    navigator.userAgent.indexOf("Electron/") >= 0 &&
    navigator.userAgent.indexOf("WebKit") >= 0
  );
}

/**
 * 复制图片到剪贴板（图片统一转为PNG，提升粘贴兼容性）
 * @param {String} imageUrl 图片地址
 * @returns {Promise<void>} 成功resolve，失败reject
 */
export function copyImageToClipboard(imageUrl) {
  return new Promise((resolve, reject) => {
    if (!imageUrl) {
      reject(new Error("图片地址为空"));
      return;
    }
    fetch(imageUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error("图片下载失败：" + response.status);
        }
        return response.blob();
      })
      .then((blob) => {
        return new Promise((resolve, reject) => {
          let img = document.createElement("img");
          img.onload = () => {
            let canvas = document.createElement("canvas");
            let ctx = canvas.getContext("2d");
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0, img.width, img.height);
            canvas.toBlob(resolve, "image/png");
          };
          img.onerror = () => {
            reject(new Error("图片解码失败"));
          };
          img.src = URL.createObjectURL(blob);
        });
      })
      .then((pngBlob) => {
        let data = [new window.ClipboardItem({ [pngBlob.type]: pngBlob })];
        return navigator.clipboard.write(data);
      })
      .then(() => {
        console.log("Image copied to clipboard successfully");
        resolve();
      })
      .catch((error) => {
        console.error("copyImageToClipboard error:", error);
        reject(error);
      });
  });
}

/**
 * 发送图片到吸附窗口（与话术图片发送使用同一 'type-img' 通道）
 * Electron：复制到剪贴板后通知主进程发送到吸附窗口
 * Web：仅复制到剪贴板
 * @param {String} imageUrl 图片地址
 * @returns {Promise<{sent:boolean}>} sent 是否发送到吸附窗口
 */
export async function sendImageToChat(imageUrl) {
  await copyImageToClipboard(imageUrl);
  if (isElectron() && window.require) {
    const { ipcRenderer } = window.require("electron");
    ipcRenderer.send("type-img");
    return { sent: true };
  }
  return { sent: false };
}

export { isElectron };
